import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { getTermsSectionStyles } from './TermsSection.styles';

const TermsSection = ({ isInView = false }) => {
  const styles = getTermsSectionStyles(isInView);

  return (
    <Grid container sx={styles.container}>
      {/* Section 1: Privacy Policy and Terms and Conditions */}
      <Grid size={{xs: 12, lg: 4}} pb={{xs: 5, lg: 0}}>
        <Box sx={styles.section1}>
          <Typography
            component={RouterLink}
            to="/privacy-policy"
            sx={styles.linkText}
          >
            Privacy Policy
          </Typography>
          <Typography
            component={RouterLink}
            to="/terms-and-conditions"
            sx={styles.linkText}
          >
            Terms and Conditions
          </Typography>
        </Box>
      </Grid>

      {/* Section 2: Copyright */}
      <Grid size={{xs: 12, lg: 4}} pb={{xs: 2, lg: 0}}>
        <Box sx={styles.section2}>
          <Typography sx={styles.copyrightText}>
            2026© Royal Vista, all rights reserved.
          </Typography>
        </Box>
      </Grid>

      {/* Section 3: Powered by Edge Global */}
      <Grid size={{xs: 12, lg: 4}}>
        <Box sx={styles.section3}>
          <Typography sx={styles.poweredByText}>
            Powered by
          </Typography>
          <Typography
            sx={styles.edgeGlobalText}
            onClick={() => window.open('https://www.edge-global.co/', '_blank')}
          >
            Edge Global
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default TermsSection;
